"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var trans_1 = __importDefault(require("@/plugins/trans"));
var material_1 = require("@mui/material");
var VacancyTile_1 = __importDefault(require("./VacancyTile"));
var Tile_1 = __importDefault(require("../components/Tile"));
var VacancySearchResults = function (_a) {
    var _b = _a.ready, ready = _b === void 0 ? false : _b, _c = _a.vacancies, vacancies = _c === void 0 ? [] : _c;
    var vacancyParam = (0, react_router_dom_1.useParams)().vacancyId;
    var vacancyId = (0, react_1.useMemo)(function () {
        if (!vacancyParam) {
            return undefined;
        }
        return Number(vacancyParam);
    }, [vacancyParam]);
    if (!ready) {
        return (0, jsx_runtime_1.jsx)("div", { children: trans_1.default.get('labels.frontend.vacancy.search.loading') });
    }
    if (!vacancies.length) {
        return ((0, jsx_runtime_1.jsx)(Tile_1.default, __assign({ active: true }, { children: (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: { minHeight: '150px' }, display: "flex", justifyContent: "center", alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h4", color: "primary", fontWeight: "bold" }, { children: trans_1.default.get('labels.frontend.vacancy.search.no_results') })) })) })));
    }
    return ((0, jsx_runtime_1.jsx)(material_1.Stack, __assign({ spacing: 5 }, { children: vacancies.map(function (vacancy) { return ((0, jsx_runtime_1.jsx)(VacancyTile_1.default, { vacancy: vacancy, selectedVacancyId: vacancyId }, vacancy.id)); }) })));
};
exports.default = VacancySearchResults;
